module.exports = __webpack_public_path__ + "static/images/list-3.5bf4af1.png";